import { TFunction } from "i18next";
import { NotificationType } from "node-library/dist/constants";
import { FrontendUserNotifications } from "node-library/dist/portal";

export function getNotificationHeaderDisplayText(
	notification: FrontendUserNotifications,
	translation: TFunction<"translation", undefined>,
): string {
	const notificationType: NotificationType = notification.notificationType;

	switch (notificationType) {
		case NotificationType.NEW_WORKFLOW_COMMENT_NOTIFICAITON:
			if (notification.mentioned) {
				return translation(
					"WorkflowCommentMentionNotificationHeader",
					notification.headerParams,
				) as string;
			}

			return translation(
				"NewWorkflowCommentNotificationHeader",
				notification.headerParams,
			) as string;

		// 2. Add a default case so the function ALWAYS returns a string
		default:
			console.warn("Unhandled notification type:", notificationType);
			return translation("NewNotificationGeneric");
	}
}

export function getNotificationDetailsDisplayText(
	notification: FrontendUserNotifications,
	translation: TFunction<"translation", undefined>,
): string {
	const notificationType: NotificationType = notification.notificationType;

	switch (notificationType) {
		case NotificationType.NEW_WORKFLOW_COMMENT_NOTIFICAITON:
			return notification.details;

		// 2. Add a default case so the function ALWAYS returns a string
		default:
			console.warn("Unhandled notification type:", notificationType);
			return translation("NewNotificationGeneric");
	}
}
